import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import { TablePagination, TableRow } from '@mui/material';
import TableCell from 'src/components/Table/TableCell';
import { useTranslation } from 'react-i18next';
import TablePaginationCustom from 'src/components/Table/TablePaginationCustom';
import Table from 'src/components/Table';
import CardMovementsRow from './CardMovementsRow';

if (!process.env.REACT_APP_TABLE_SIZE) {
  console.error(
    'REACT_APP_TABLE_SIZE variable not loaded properly. Check your .env file please!'
  );
}

const Tbody = ({ movements }) =>
  movements.map(movement => (
    <CardMovementsRow key={movement.id} {...movement} />
  ));

const CardMovementsTable = ({
  className,
  movements,
  count,
  page,
  handleChangePage,
  loading,
  ...rest
}) => {
  const { t } = useTranslation();

  const theads = useMemo(
    () => () => (
      <TableRow component="tr">
        <TableCell style={{ width: '18%' }} align="center">
          {t('COMMON.CLIENT')}
        </TableCell>
        <TableCell style={{ width: '16%' }} align="center">
          {t('CARD_MOVEMENTS.CHARGE_ID')}
        </TableCell>
        <TableCell style={{ width: '13%' }} align="center">
          {t('CARD_MOVEMENTS.CARD')}
        </TableCell>
        <TableCell style={{ width: '13%' }} align="center">
          {t('CARD_MOVEMENTS.INVOICE_AMOUNT')}
        </TableCell>
        <TableCell style={{ width: '13%' }} align="center">
          {t('CARD_MOVEMENTS.COMMISSION_AMOUNT')}
        </TableCell>
        <TableCell style={{ width: '14%' }} align="center">
          {t('COMMON.DATE')}
        </TableCell>
        <TableCell style={{ width: '13%' }} align="center">
          {t('COMMON.STATUS')}
        </TableCell>
      </TableRow>
    ),
    [t]
  );

  const tbody = useMemo(() => () => <Tbody movements={movements} />, [
    movements
  ]);

  const pagination = useMemo(
    () => () => (
      <TablePagination
        rowsPerPageOptions={[]}
        component="div"
        count={count}
        rowsPerPage={+process.env.REACT_APP_TABLE_SIZE}
        page={page}
        onPageChange={handleChangePage}
        ActionsComponent={TablePaginationCustom}
        labelDisplayedRows={({ from, to, count: c }) => {
          return `${from}-${to} ${t('COMMON.OF')} ${c}`;
        }}
      />
    ),
    [page, movements, count, handleChangePage, t]
  );

  return (
    <Table
      {...rest}
      variant="outlined"
      tbody={tbody}
      theads={theads}
      pagination={pagination}
      loading={loading}
    />
  );
};

CardMovementsTable.propTypes = {
  className: PropTypes.string,
  movements: PropTypes.array.isRequired,
  count: PropTypes.number,
  page: PropTypes.number,
  handleChangePage: PropTypes.func,
  loading: PropTypes.bool
};

CardMovementsTable.defaultProps = {
  count: 0,
  page: 0,
  loading: false
};

export default CardMovementsTable;
